// GlobalStyles.js
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    '@global': {
        '*::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
        },
        '*::-webkit-scrollbar-track': {
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1c1c1',
            borderRadius: '4px',
            border: '2px solid transparent',
            backgroundClip: 'content-box',
        },
        '*::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#a0a0a0',
        },
        '*': {
            scrollbarWidth: 'thin',
            scrollbarColor: '#c1c1c1 #f0f0f0', // Firefox support
        },
    },
}));

export default function GlobalStyles() {
    useStyles(); // Run the hook to inject global styles
    return null; // Doesn't render anything
}
